import React from 'react';

import './style.scss';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import {
  Image,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import Truncate from 'react-truncate';
import classNames from 'classnames';
import { API_URL } from '../../../../config/constants';
import { NodeProject } from '../../../../types/uncinc_profile/nodes';

interface NodeProjectTeaserProps extends React.ComponentPropsWithoutRef<'div'> {
  entity: ImmutableEntity<NodeProject>;
  classes: string;
}

const NodeProjectTeaser: React.FC<NodeProjectTeaserProps> = ({ entity, classes, ...props }) => {
  const project = entity.toJS();
  const title = project.title[0].value;
  const imageStyles = project.field_media_item[0]?.styles;
  const src = [
    `${API_URL}${imageStyles?.ratio_1_1_xs || ''}`,
    `${API_URL}${imageStyles?.ratio_1_1_sm || ''}`,
    `${API_URL}${imageStyles?.ratio_1_1_md || ''}`,
    `${API_URL}${imageStyles?.ratio_1_1_xl || ''}`,
  ];

  return (
    <div className={classNames('ProjectTeaser', classes)} {...props}>
      <div className="ProjectTeaser__image">
        <Image
          src={src}
          alt={title}
        />
      </div>
      <div className="ProjectTeaser__content">
        <h3 className="ProjectTeaser__heading">
          <Truncate lines={2} ellipsis="...">
            <WysiwygField
              html={title}
            />
          </Truncate>
        </h3>
        <Truncate lines={3}>
          <WysiwygField
            html={project.body[0]?.summary}
            className="foo"
          />
        </Truncate>
      </div>
    </div>
  );
};

export default NodeProjectTeaser;
